import {
  organizerInfoSelector,
  organizerIsLoadedSelector,
  organizerIsLoadingSelector,
  organizerIsSavingSelector,
} from 'modules/organizer/store/organizer/selectors';
import { useMemo } from 'react';

import { useSelector } from 'react-redux';

export const useOrganizer = () => {
  const isLoading = useSelector(organizerIsLoadingSelector);
  const isLoaded = useSelector(organizerIsLoadedSelector);
  const isSaving = useSelector(organizerIsSavingSelector);
  const info = useSelector(organizerInfoSelector);

  return useMemo(
    () => ({
      isLoading,
      isLoaded,
      isSaving,
      info,
    }),
    [isLoading, isLoaded, isSaving, info],
  );
};
